import React from 'react';
import PropTypes from 'prop-types';

const ProductCategory = (props) => {
  const ifSubCategoryExists = props._source.subcategory;

  return (
    <div className="sk-hits-list-hit__category">
      <div>{props._source.category}</div>
      { ifSubCategoryExists &&
        <div>{props._source.subcategory}</div>
      }
    </div>
  )
};

ProductCategory.propTypes = {
  _source: PropTypes.shape({
    category: PropTypes.string,
    subcategory: PropTypes.string
  })
};

export default ProductCategory;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/ProductListItems/ProductCategory.jsx